import { get, post } from '../axios'

export function popupWindow_rule_page(map) {
  return get(`${process.env.VUE_APP_COMMON}/popupWindow/rule/page`, map)
}

export function popupWindow_rule_enable(map) {
  return post(`${process.env.VUE_APP_COMMON}/popupWindow/rule/enable`, map)
}

export function popupWindow_base_popupStyleList(map) {
  return get(
    `${process.env.VUE_APP_COMMON}/popupWindow/base/popupStyleList`,
    map
  )
}

export function popupWindow_base_effectivePageList(map) {
  return get(
    `${process.env.VUE_APP_COMMON}/popupWindow/base/effectivePageList`,
    map
  )
}

export function popupWindow_base_popupTypeList(map) {
  return get(
    `${process.env.VUE_APP_COMMON}/popupWindow/base/popupTypeList`,
    map
  )
}

export function popupWindow_rule_add(map) {
  return post(`${process.env.VUE_APP_COMMON}/popupWindow/rule/add`, map)
}

export function popupWindow_rule_edit(map) {
  return post(`${process.env.VUE_APP_COMMON}/popupWindow/rule/edit`, map)
}

export function popupWindow_rule_detail(map) {
  return get(`${process.env.VUE_APP_COMMON}/popupWindow/rule/detail/${map.id}`)
}

export function popupWindow_rule_delete(map) {
  return post(`${process.env.VUE_APP_COMMON}/popupWindow/rule/delete/${map.id}`)
}

export function popupWindow_main_page(map) {
  return get(`${process.env.VUE_APP_COMMON}/popupWindow/main/page`, map)
}

export function popupWindow_main_add(map) {
  return post(`${process.env.VUE_APP_COMMON}/popupWindow/main/add`, map)
}

export function popupWindow_base_behaviorConditionList(map) {
  return get(
    `${process.env.VUE_APP_COMMON}/popupWindow/base/behaviorConditionList`,
    map
  )
}
